/* eslint-disable react/prefer-es6-class */
/* eslint-disable react/jsx-no-bind */
import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';

import EditCategoryModal from './modals/EditCategoryModal';
import DeleteCategoryModal from './modals/DeleteCategoryModal';
import RestrictedComponent, { hasPermission } from '../../../lib/components/form/RestrictedComponent';
import schema from '../../../routes/permissions/schema';

var ChildCategory = createReactClass({

    getInitialState: function () {
        return {
            editModal: false,
            deleteModal: false
        };
    },

    handleRemove: function () {
        this.props.actions.edit({
            categoryID: this.props.child.categoryID,
            categoryName: this.props.child.categoryName,
            childOf: null
        });
    },

    toggleDeleteModal: function () {
        this.setState({
            deleteModal: !this.state.deleteModal
        });
    },

    toggleEditModal: function () {
        this.setState({
            editModal: !this.state.editModal
        });
    },

    render: function () {
        var { child, mode, assigned } = this.props;

        // Don't render this child if it's already been assigned to an event
        if (mode == 'event' && assigned.indexOf(child.categoryName) > -1) {
            return <div/>;
        }

        return (<div className="panel panel-body child-category">
            <div className="col-md-8">
                <h5>{child.categoryName}</h5>
                <p><i>Display Name:</i> {child.displayName || ''}</p>
                <p><i>Description:</i> {child.categoryDescription || ''}</p>
            </div>
            <div className="col-md-4 text-right">
                {this.renderActions()}
            </div>

            {this.renderModals()}
        </div>);
    },

    renderActions: function () {
        const inAssignedGroup = !this.props.isAssignedGroup || 
            (this.props.isAssignedGroup && 
                this.props.assignedCategories.some(category => category.categoryID === this.props.child.categoryID)
            )
        const groupPermissionLabel = !inAssignedGroup ? 'You do not have this category assigned to your content groups' : undefined
        switch (this.props.mode) {
            case 'manage':
                return (<div>
                    <RestrictedComponent label={groupPermissionLabel} permissionCheck={hasPermission(schema.MANAGE_CLIENT_CATEGORIES.UPDATE) && inAssignedGroup}>
                        <button className="btn btn-warning remove-category" onClick={this.handleRemove}>
                            <i className="fa fa-minus-circle"/> Remove
                        </button>
                    </RestrictedComponent>
                    <div className="btn-group">
                        <RestrictedComponent label={groupPermissionLabel} permissionCheck={hasPermission(schema.MANAGE_CLIENT_CATEGORIES.UPDATE) && inAssignedGroup}>
                            <button className="btn btn-default" onClick={this.toggleEditModal}>
                                <i className="fa fa-pencil"/> Edit
                            </button>
                        </RestrictedComponent>
                        <RestrictedComponent label={groupPermissionLabel} permissionCheck={hasPermission(schema.MANAGE_CLIENT_CATEGORIES.DELETE) && inAssignedGroup}>
                            <button className="btn btn-default" onClick={this.toggleDeleteModal}>
                                <i className="fa fa-trash-can"/> Delete
                            </button>
                        </RestrictedComponent>
                    </div>
                </div>);

            case 'event':
                return (<div>
                    <button className="btn btn-default" onClick={this.props.assignCategoryToEvent.bind(null, this.props.child.categoryID)}>
                        <i className="fa fa-check"/> Assign
                    </button>
                </div>);
        }
    },

    renderModals: function () {
        var sharedProps = {
            actions: this.props.actions,
            category: this.props.child,
            categories: this.props.categories,
            nested: this.props.nested
        };

        if (this.state.editModal) {
            return <EditCategoryModal
                {...sharedProps} toggle={this.toggleEditModal}
            />;
        } else if (this.state.deleteModal) {
            return <DeleteCategoryModal
                {...sharedProps} toggle={this.toggleDeleteModal}
            />;
        }
    }

});

export default ChildCategory;
